<template>
  <div id="header">
    <v-app-bar flat dark color="headerBack" height="64">

      <v-toolbar-title class="width-100" @click="jumpTop()">
        <!--<div class="line-height-s center-align item-flex-center-heder" :class="{'padding-right-70': $vuetify.display.xs || $vuetify.display.sm}">-->
        <div class="line-height-s center-align item-flex-center-heder">
          <img :src="logoHeader" height="36">
          <div class="pl-2" v-if="!($vuetify.display.xs || $vuetify.display.sm)">
            <div v-if="topTeamName">
              <span class="font-bold font-color-header-text">{{globalSchoolNameEn}}</span>
              <span class="font-medium-xl pl-2 font-color-header-text">{{globalSchoolTypeEn}}</span>
            </div>
            <div v-else>
              <img v-if="!topTeamName" :src="'../../assets/img/header_text.png'" height="36px" @error="topTeamName = true"/>
            </div>
          </div>
        </div>
      </v-toolbar-title>

      <div class="position-absolute position-4-right" v-if="!$route.meta.isEvent || (!($vuetify.display.xs || $vuetify.display.sm || $vuetify.display.md) && !!$route.meta.isEvent)">
        <span v-if="!!$route.meta.isEvent">
          <a href="/" class="font-color-header-text font-bold font-medium-l link-decoration-none px-3">スクールシステムへ<v-icon size="11px" class="ml-1 rotate-90" color="headerText">mdi-triangle</v-icon></a>
          <div class="px-2 font-color-header-text item-inline">|</div>
        </span>
        <span v-if="!!$route.meta.isEvent">
          <a href="#" class="font-color-header-text font-bold font-medium-l link-decoration-none px-3" @click.stop="openEventManual()">サイトの使い方<v-icon size="11px" class="ml-1 rotate-90" color="headerText">mdi-triangle</v-icon></a>
          <div class="px-2 font-color-header-text item-inline">|</div>
        </span>
        <v-btn id="header-logout" color="headerBack" variant="flat" v-if="$store.state.logined" @click="logout()">
          <span class="font-bold font-color-logout-btn-text">ログアウト</span>
          <v-icon right color="logoutBtnText">mdi-logout</v-icon>
        </v-btn>
        <v-btn id="header-login" color="headerBack" variant="flat" v-else @click="jumpLogin()">
          <span class="font-bold font-color-logout-btn-text">ログイン</span>
          <v-icon right color="logoutBtnText">mdi-login</v-icon>
        </v-btn>
      </div>
      <v-app-bar-nav-icon @click="drawer=!drawer" color="headerText" v-else></v-app-bar-nav-icon>
    </v-app-bar>
    <transition name="menu">
      <div class="menu" v-show="drawer" v-if="($vuetify.display.xs || $vuetify.display.sm || $vuetify.display.md)">
        <v-icon color="#fff" @click="drawer=!drawer" class="menu-close">mdi-close</v-icon>
        <ul class="list-style-none pl-0">
          <li>
            <a href="/" class="font-color-white font-bold font-medium-l link-decoration-none">
              <span class="">スクールシステムへ</span>
              <span class="float-right">
                <v-icon size="11px" class="ml-1 rotate-90" color="#fff">mdi-triangle</v-icon>
              </span>
            </a>
            <div class="boder-bottom-white my-5"></div>
          </li>
          <li>
            <a href="#" class="font-color-white font-bold font-medium-l link-decoration-none" @click.stop="openEventManual()">
              <span class="">サイトの使い方</span>
              <span class="float-right">
                <v-icon size="11px" class="ml-1 rotate-90" color="#fff">mdi-triangle</v-icon>
              </span>
            </a>
            <div class="boder-bottom-white my-5"></div>
          </li>
          <li v-if="$store.state.logined" @click="logout();drawer = false">
            <span class="font-color-white font-bold font-medium-l">
              <span class="">ログアウト</span>
              <span class="float-right">
                <v-icon size="11px" class="ml-1 rotate-90" color="#fff">mdi-triangle</v-icon>
              </span>
              <div class="boder-bottom-white my-5"></div>
            </span>
          </li>
          <li v-else @click="jumpLogin()">
            <span class="font-color-white font-bold font-medium-l">
              <span class="">ログイン</span>
              <span class="float-right">
                <v-icon size="11px" class="ml-1 rotate-90" color="#fff">mdi-triangle</v-icon>
              </span>
              <div class="boder-bottom-white my-5"></div>
            </span>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'approach-header',
  data: function () {
    return {
      teamFlag: true,
      topTeamName: false,
      drawer: false
    }
  },
  mounted: function () {
    if (this.$route.query.team) {
      this.vegalta = this.$route.query.team
      this.teamFlag = false
    }
    console.log(this.$route)
  },
  methods: {
    logout: function () {
      this.globalLogout()
      if (this.eventTopList.filter(v => v === this.$route.name).length > 0) {
        if (this.$store.state.jid) {
          window.localStorage.setItem('portalPageJamp', '/event')
        }
        this.$router.push('/event')
      } else {
        this.$router.push('/')
      }
    },
    jumpTop: function () {
      this.$router.push('/')
    },
    jumpLogin: function () {
      if (this.$route.meta.isEvent) {
        this.$store.commit('setEventType', 1)
        this.$router.push('/event/login?to=' + this.$route.fullPath)
      } else {
        this.$router.push('/login?to=' + this.$route.fullPath)
      }
    },
    openEventManual: function () {
      const self = this
      const fileName = 'member/イベントシステム操作マニュアル.pdf'
      const windowReference = window.open()
      this.$store.commit('startLoading')
      this.globalGetManual(fileName).then(url => {
        self.$store.commit('finishLoading')
        if (url) {
          windowReference.location = url
        }
      })
    }
  }
}
</script>

<style scoped>
.item-flex-center-heder{
  display: flex !important;
  align-items: center;
  justify-content: center;
}
.menu-position{
  right: -7px !important;
  top: -13px !important;
}
.menu-text{
  position: absolute;
  top: 35px;
  right: 4px;
}
.item-flex-center-heder{
  display: flex !important;
  align-items: center;
  justify-content: center;
}

.item-flex-heder{
  display: flex !important;
  align-items: center;
  justify-content: space-between;
}
.menu{
    background-color: rgb(0 0 0 / 70%);
    z-index: 99999;
    padding: 2rem 1rem;
    position: fixed;
    width: 100vw;
    height: 100vh;
    top: 0;
    right: 0;
    color:#fff;
}

.menu li a {
  width: 100%;
  display: block;
  position: relative;
}
.menu-list-text{
  width: 80%;
  display: block;
}
.menu-icon-content{
  position: absolute;
  top: 50%;
  right: 0px;
  transform: translateY(-50%);
  margin-left: 3px;
}

.menu-close{
  margin:0 0 30px auto;
  display:block;
}
.menu-enter-active, .menu-leave-active {
  transition: opacity 0.2s;
}
.menu-enter, .menu-leave-to {
  opacity: 0;
}
.menu-leave, .menu-enter-to{
  opacity: 1;
}
</style>
